"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloudToDevice = exports.DeviceToCloud = exports.C2DMessage = exports.D2CMessage = exports.PrefsC2DMessage = exports.PrefsD2CMessage = exports.ConsumableC2DMessage = exports.ConsumableD2CMessage = exports.TelemetryC2DMessage = exports.TelemetryD2CMessage = exports.SystemC2DMessage = exports.StateC2DMessage = exports.StateD2CMessage = exports.AlarmD2CMessage = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const sync_ro_1 = require("../../../device/class/sync-ro");
const common_1 = require("../../common");
const Alarm = __importStar(require("../alarm"));
const Consumable = __importStar(require("../consumable"));
const Prefs = __importStar(require("../prefs"));
const State = __importStar(require("../state"));
const System = __importStar(require("../system"));
const Telemetry = __importStar(require("../telemetry"));
exports.NAMESPACE = 'Culligan.Protocol.V3.Device.SyncRo';
exports.AlarmD2CMessage = Alarm.createD2CMessage(exports.NAMESPACE, sync_ro_1.SyncRo.alarms.firmwareBased);
exports.StateD2CMessage = State.createD2CMessage(sync_ro_1.SyncRo.State).annotations({
    identifier: `${exports.NAMESPACE}.StateD2CMessage`,
});
exports.StateC2DMessage = State.createC2DMessage(sync_ro_1.SyncRo.State).annotations({
    identifier: `${exports.NAMESPACE}.StateC2DMessage`,
});
exports.SystemC2DMessage = System.C2DMessage.annotations({
    identifier: `${exports.NAMESPACE}.SystemC2DMessage`,
});
exports.TelemetryD2CMessage = Telemetry.createD2CMessage(sync_ro_1.SyncRo.Telemetry).annotations({
    identifier: `${exports.NAMESPACE}.TelemetryD2CMessage`,
});
exports.TelemetryC2DMessage = Telemetry.C2DMessage.annotations({
    identifier: `${exports.NAMESPACE}.TelemetryC2DMessage`,
});
exports.ConsumableD2CMessage = Consumable.createD2CMessage(exports.NAMESPACE, sync_ro_1.SyncRo.slots);
exports.ConsumableC2DMessage = Consumable.createC2DMessage(exports.NAMESPACE, sync_ro_1.SyncRo.slots, sync_ro_1.SyncRo.Catalogue);
exports.PrefsD2CMessage = Prefs.createD2CMessage(exports.NAMESPACE, sync_ro_1.SyncRo.Prefs);
exports.PrefsC2DMessage = Prefs.createC2DMessage(exports.NAMESPACE, sync_ro_1.SyncRo.Prefs);
exports.D2CMessage = effect_1.Schema.Union(exports.AlarmD2CMessage, exports.ConsumableD2CMessage, exports.StateD2CMessage, exports.TelemetryD2CMessage, exports.PrefsD2CMessage).annotations({
    identifier: `${exports.NAMESPACE}.D2CMessage`,
});
exports.C2DMessage = effect_1.Schema.Union(exports.ConsumableC2DMessage, exports.StateC2DMessage, exports.SystemC2DMessage, exports.TelemetryC2DMessage, exports.PrefsC2DMessage).annotations({
    identifier: `${exports.NAMESPACE}.C2DMessage`,
});
exports.DeviceToCloud = common_1.Payload.create(3, sync_ro_1.SyncRo, exports.D2CMessage, {
    title: `${sync_ro_1.SyncRo.label} — Device to Cloud Protocol`,
}).annotations({
    identifier: `${exports.NAMESPACE}.DeviceToCloud`,
    title: `${sync_ro_1.SyncRo.label} — Device to Cloud Protocol`,
});
exports.CloudToDevice = common_1.Payload.create(3, sync_ro_1.SyncRo, exports.C2DMessage, {
    title: `${sync_ro_1.SyncRo.label} — Cloud to Device Protocol`,
}).annotations({
    identifier: `${exports.NAMESPACE}.CloudToDevice`,
    title: `${sync_ro_1.SyncRo.label} — Cloud to Device Protocol`,
});
//# sourceMappingURL=sync-ro.js.map